import { EnvironmentState } from './environment';

export type PageLocation = {
  pageId: string;
  pathname: string;
  search?: string;
  hash?: string;
};

export type PageParams = {
  location: PageLocation;
  displayMode: 'main' | 'overlay';
};

export type StateObserver<
  P = {},
  E extends EnvironmentState = EnvironmentState,
> = (params: P, environmentState: E) => void;

export type ObserveState = <
  P = {},
  E extends EnvironmentState = EnvironmentState,
>(
  observer: StateObserver<P, E>,
) => {
  disconnect: () => void;
};
